<template>
  <div class="overlay">
    <div class="overlay_inner table_settings">
      <div class="available_cols">
        <div class="cols_inner scroll">
          <p class="note" v-translate>Dostupné sloupce</p>
          <ul>
            <li v-for="(item, index) in columns">
              <input :id="index"
                     :name="item.name"
                     type="checkbox"
                     :value="index"
                     :checked="inSelection(index)"
                     :disabled="item.disabled"
                     @change="onSelectionChange(index)">
              <label :for="index">{{ item.name }}</label>
            </li>

          </ul>
        </div>
      </div>
      <div class="selected_cols">
        <div class="cols_inner scroll">
          <p class="note">{{$gettext('Vybrané sloupce')}}<span class="col_number">({{selection.length}})</span></p>
          <ul>
            <li v-for="itemId in selection" :itemvalue="itemId">{{columns[itemId].name}} ({{itemId}})<a class="remove_col" @click="onSelectionChange(itemId)" :title="'Odebrat' | translate" v-translate>Odebrat</a></li>
          </ul>
        </div>
      </div>

      <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose"
         v-translate>Zavřít</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelectColumns",
  props: {
    columns: Object
  },
  mounted() {
      $( ".selected_cols ul" ).sortable({
        axis: "y",
        revert: 300,
        scrollSpeed: 30,
        scrollSensitivity: 120,
        tolerance: "pointer",
        stop: this._valuesSorted
      });
  },
  data:
      function () {
        return {
          selection: [],
        };
      },
  methods: {
    initSelection(selection){
      this.selection = selection;
    },
    inSelection(index){
      return this.selection.includes(index);
    },
    onSelectionChange(index){
      if(this.inSelection(index)){
        const arrayIndex = this.selection.indexOf(index);
        if (arrayIndex > -1) {
          this.selection.splice(arrayIndex, 1);
        }
      }else{
        this.selection.push(index);
      }
      this.emitChange(this.selection);
    },
    _valuesSorted() {

      let orderedValues = [];
      $(".selected_cols ul li").each((el, x) => {
        orderedValues.push($(x).attr('itemvalue'));
      });

      this.emitChange(orderedValues);
    },
    emitChange(data) {
      this.$emit('change', data);
    },
    emitClose() {
      this.$emit('close-popup');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/tabs/SelectColumns.vue